import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';
import { useSelector, useDispatch } from 'react-redux';
import usePreview from './usePreview';
import usePortal from './usePortal';
import '../../../../../../styles.css'; // Ensure styles.scss is imported in your project's setup

// import { close } from './images/assets/close.svg';
// import plus from './images/assets/plus.svg';
// import minus from './images/assets/minus.svg';
// import zoomIn from './images/assets/zoom-in.svg';
// import zoomOut from './images/assets/zoom-out.svg';
import { closeFullscreenPreview } from '../../../../store/actions';

const FullScreenPreview = ({ fullScreenMode, zoomStep }) => {
  const { state, initFileSize, onZoomIn, onZoomOut, onResizePageZoom } = usePreview(zoomStep);
  const dispatch = useDispatch();

  const { src, alt, width, height, visible } = useSelector((state) => ({
    src: state.preview.src,
    alt: state.preview.alt,
    width: state.preview.width,
    height: state.preview.height,
    visible: state.preview.visible
  }));

  useEffect(() => {
    if (src) {
      initFileSize(width, height);
    }
  }, [src, initFileSize, width, height]);

  const pDom = usePortal();

  const onClosePreview = () => {
    dispatch(closeFullscreenPreview());
  };

  const handleResizePageZoom = () => {
    onResizePageZoom();
  };

  const handleZoomIn = () => {
    onZoomIn();
  };

  const handleZoomOut = () => {
    onZoomOut();
  };

  return visible
    ? ReactDOM.createPortal(
        <div className="rcw-previewer-container">
          <div className="rcw-previewer-veil">
            <img {...state.layout} src={src} className="rcw-previewer-image" alt={alt} />
          </div>
          <button
            className="rcw-previewer-button rcw-previewer-close-button"
            onClick={onClosePreview}>
            <img src="./images/assets/close.svg" className="rcw-previewer-icon" alt="close" />
          </button>
          <div className="rcw-previewer-tools">
            <button className="rcw-previewer-button" onClick={handleResizePageZoom}>
              <img
                src={state.zoom ? './images/assets/zoom-out.svg' : './images/assets/zoom-in.svg'}
                className="rcw-previewer-icon"
                alt="reset zoom"
              />
            </button>
            <button className="rcw-previewer-button" onClick={handleZoomIn}>
              <img src="./images/assets/plus.svg" className="rcw-previewer-icon" alt="zoom in" />
            </button>
            <button className="rcw-previewer-button" onClick={handleZoomOut}>
              <img src="./images/assets/minus.svg" className="rcw-previewer-icon" alt="zoom out" />
            </button>
          </div>
        </div>,
        pDom
      )
    : null;
};

export default FullScreenPreview;
